<div class="out">


  <kpay-wnd *ngIf="state=='pay'" class="abs_center"></kpay-wnd>
  <kplan-wnd *ngIf="state=='plan'" class="abs_center"></kplan-wnd>
  <kplan-error *ngIf="state=='error'" (close)="closeErr()" class="abs_center"></kplan-error>

</div>
